import { IMenuItem } from '../../../types/menuItems'
import * as constants from '../actions/constants'
import { SidebarActions } from '../actions/sidebarActions'

export const activeMenuItem = (state: IMenuItem = { name: '', path: '', active: false, rights: [] }, action: SidebarActions): IMenuItem => {
  switch(action.type) {
    case constants.SET_ACTIVE_MENU_ITEM:
      return { name: action.item, path: action.path, active: true, rights: [] }

    default:
      return state
  }
}

export const activeSubMenuItem = (state: IMenuItem = { name: '', path: '', active: false, rights: [] }, action: SidebarActions): IMenuItem => {
  switch(action.type) {
    case constants.SET_ACTIVE_SUB_MENU_ITEM:
      return { name: action.item, path: action.path, active: true, rights: [] }

    default:
      return state
  }
}

export const activeDropdownMenuItem = (state: IMenuItem = { name: '', path: '', active: false, rights: [] }, action: SidebarActions): IMenuItem => {
  switch(action.type) {
    case constants.SET_ACTIVE_DROPDOWN_MENU_ITEM:
      return { name: action.item, path: action.path, active: true, rights: [] }

    default:
      return state
  }
}

export const sidebarVisible = (state = false, action: SidebarActions): boolean => {
  switch(action.type) {
    case constants.TOGGLE_SIDEBAR:
      return action.visible

    default:
      return state
  }
}

export const openConfirmModal = (state = false, action: SidebarActions): boolean => {
  switch(action.type) {
    case constants.OPEN_CONFIRM_MODAL:
      return action.open

    default:
      return state
  }
}

export const formOpen = (state = false, action: SidebarActions): boolean => {
  switch(action.type) {
    case constants.SET_FORM_OPEN:
      return action.open

    default:
      return state
  }
}


export const formDirty = (state = false, action: SidebarActions): boolean => {
  switch(action.type) {
    case constants.SET_FORM_DIRTY:
      return action.dirty

    default:
      return state
  }
}
